
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function Construction() {
  const services = [
    {
      id: 1,
      title: 'Residential Construction',
      description: 'Custom homes, additions, and renovations with quality craftsmanship',
      image: 'https://public.readdy.ai/ai/img_res/09a712397d15b8ececda2aeef8c9361e.jpg',
      features: ['Custom Design', 'Quality Materials', 'Licensed Contractors', 'Warranty Included']
    },
    {
      id: 2,
      title: 'Commercial Buildings',
      description: 'Office buildings, retail spaces, and industrial construction',
      image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20building%20construction%20with%20red%20brick%20facade%2C%20office%20building%2C%20business%20architecture%2C%20professional%20construction%2C%20urban%20development%2C%20commercial%20real%20estate&width=400&height=300&seq=12&orientation=landscape',
      features: ['Project Management', 'Code Compliance', 'Timeline Adherence', 'Budget Control']
    },
    {
      id: 3,
      title: 'Renovations & Additions',
      description: 'Transform existing spaces with expert renovation services',
      image: 'https://readdy.ai/api/search-image?query=Home%20renovation%20and%20addition%20project%2C%20construction%20work%2C%20remodeling%2C%20home%20improvement%2C%20before%20and%20after%20transformation%2C%20professional%20renovation%20services&width=400&height=300&seq=13&orientation=landscape',
      features: ['Space Planning', 'Permit Handling', 'Minimal Disruption', 'Quality Finishes']
    }
  ];

  const process = [
    {
      step: 1,
      title: 'Consultation',
      description: 'We meet to discuss your vision, needs, and budget',
      icon: 'ri-discuss-line'
    },
    {
      step: 2,
      title: 'Design & Planning',
      description: 'Our team creates detailed plans and obtains permits',
      icon: 'ri-draft-line'
    },
    {
      step: 3,
      title: 'Construction',
      description: 'Professional execution with regular progress updates',
      icon: 'ri-hammer-line'
    },
    {
      step: 4,
      title: 'Completion',
      description: 'Final inspection and handover of your project',
      icon: 'ri-check-double-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('https://readdy.ai/api/search-image?query=Construction%20site%20with%20red%20brick%20buildings%2C%20construction%20workers%2C%20building%20equipment%2C%20professional%20construction%20company%2C%20modern%20architecture%2C%20construction%20industry%20background&width=1920&height=600&seq=14&orientation=landscape')`
        }}
      >
        <div className="text-center text-white max-w-4xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Construction Services</h1>
          <p className="text-xl">Building quality structures with precision and care</p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Construction Services</h2>
            <p className="text-xl text-gray-600">Professional construction solutions for every need</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div key={service.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-gray-700">
                        <i className="ri-check-line text-green-600 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Construction Process</h2>
            <p className="text-xl text-gray-600">From concept to completion, we guide you every step</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {process.map((item) => (
              <div key={item.step} className="text-center">
                <div className="w-16 h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <div className="bg-red-700 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto mb-4 text-sm font-bold">
                  {item.step}
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Why Choose BrickGreen Construction?</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-red-700 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-award-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">25+ Years Experience</h3>
                    <p className="text-gray-600">Decades of construction expertise and satisfied customers</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-red-700 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Licensed & Insured</h3>
                    <p className="text-gray-600">Fully licensed contractors with comprehensive insurance coverage</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-red-700 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-time-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">On-Time Delivery</h3>
                    <p className="text-gray-600">We respect your timeline and deliver projects as promised</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20construction%20team%20working%20on%20red%20brick%20building%2C%20construction%20workers%2C%20safety%20equipment%2C%20teamwork%2C%20quality%20construction%2C%20professional%20contractors%2C%20construction%20site&width=600&height=500&seq=15&orientation=portrait"
                alt="Construction Team"
                className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">Ready to Build Your Dream?</h2>
          <p className="text-xl text-red-100 mb-8">
            Contact us today for a free consultation and detailed quote
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-red-700 hover:bg-gray-100">
              Get Free Consultation
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
